import { root } from '../../../../store/constants';

export const reset = () => {
    root.analytics && root.analytics.reset();
    // root.mixpanel.cookie.clear();
};
